import { BROKEN_IMAGE_SRC } from "@remi/constants";
import { FileType } from "@remi/types/file";

import type { FileById } from "./useFile";

// findMany omits files that do not exist, so the batcher answers for them with this rather than leaving
// the caller a runtime error. Its own module so a test that mocks useFile can still build a FileById.
export const buildMissingFile = (id: string): FileById => ({
  id,
  name: "File not found",
  url: BROKEN_IMAGE_SRC,
  type: FileType.PHOTO,
  person: null,
  tags: [],
  createdAt: new Date("1970-01-01T00:00:00Z"), // old date to avoid sorting issues
  updatedAt: new Date("1970-01-01T00:00:00Z"),
  task: null,
  contractorLicenses: [],
  bill: null,
  role: null,
  thumbnailUrl: undefined,
  deletable: false,
  deliveredToXa: false,
  xaDeliveredAt: null,
  isDeleted: false,
  metadataCreatedAt: null,
  pricingSheetReason: null,
  expiresAt: null,
  contractorDocumentStatus: null,
  aiSummary: null,
  thumbnailUploadedAt: null,
  uploadedAt: null,
  assignmentId: null,
  billId: null,
  receiptId: null,
  taskId: null,
  personId: null,
  workSiteId: null,
  projectId: null,
  invoiceId: null,
  messageId: null,
  creditMemoId: null,
  changeOrderId: null,
  vendorCreditId: null,
  contractorProfileId: null,
  complianceEventId: null,
  bidRequestId: null,
  emailId: null,
  smsMessageId: null,
  estimateId: null,
  parentFileId: null,
  statusNotes: null,
});
